import ModalLocationCreate from './ModalLocationCreate';

export default ModalLocationCreate;
